import { CustomerEntity } from '../../httpClient/interfaces/CustomerEntity'
import { User } from '../interfaces/User'
import { ProvidersType } from '../../interfaces/Providers'

/** --------------------------------------  GET  ------------------------------------------ **/

/**
 * Get user info in sessionStorage
 */
export const getCurrentUserInfo = (): User => JSON.parse(sessionStorage.getItem('user') ?? '{}')

/**
 * Get user roles in sessionStorage
 */
export const getCurrentUserRoles = (): string[] => JSON.parse(sessionStorage.getItem('roles') ?? '[]')

/**
 * Get user provider in sessionStorage
 */
export const getCurrentProvider = (): ProvidersType | '' => (sessionStorage.getItem('provider') as ProvidersType) ?? ''

/**
 * get current customerEntity in sessionStorage
 */
export const getCurrentCustomerEntity = (): CustomerEntity =>
    JSON.parse(sessionStorage.getItem('currentCustomerEntity')) ?? {}

/**
 * get CustomerEntities in sessionStorage
 */
export const getCustomerEntities = (): CustomerEntity[] => JSON.parse(sessionStorage.getItem('customerEntities')) ?? {}

/** --------------------------------------  SET  ------------------------------------------ **/

/**
 * Set user info in sessionStorage
 */
export const setCurrentUserInfo = (user: User) => sessionStorage.setItem('user', JSON.stringify(user))

/**
 * Set user roles in sessionStorage
 */
export const setCurrentUserRoles = (roles: string[]) => sessionStorage.setItem('roles', JSON.stringify(roles))

/**
 * Set user provider in sessionStorage
 */
export const setCurrentProvider = (provider: ProvidersType | '') => sessionStorage.setItem('provider', provider)

/**
 * Set current customerEntity in sessionStorage
 */
export const setCurrentCustomerEntity = (currentCustomerEntity: CustomerEntity) =>
    sessionStorage.setItem('currentCustomerEntity', JSON.stringify(currentCustomerEntity))

/**
 * Set CustomerEntities in sessionStorage
 */
export const setCustomerEntities = (customerEntities: CustomerEntity[]) =>
    sessionStorage.setItem('customerEntities', JSON.stringify(customerEntities))
